export default "__VITE_ASSET__D3rxcuWf__"